import { CHANGE_ODD_TYPE } from './actionTypes'

export const changeOddType = (oddType: any) => ({
    type: CHANGE_ODD_TYPE,
    oddType,
})